import React from 'react';
import '../styles/Python.css';

function Python() {
  return (
    <div className="Python">
      <h1>Projetos em Python</h1>
      <ul className="container_python">
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-algorithms"
            target="_blank"
            rel="noopener noreferrer"
          >
            Algoritmos
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-ting"
            target="_blank"
            rel="noopener noreferrer"
          >
            TING - Trybe Is Not Google
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/restaurant-orders"
            target="_blank"
            rel="noopener noreferrer"
          >
            Restaurant Orders
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-pro-filer"
            target="_blank"
            rel="noopener noreferrer"
          >
            ProFiler
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-inventory-report"
            target="_blank"
            rel="noopener noreferrer"
          >
            Relatório de Estoques
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-tech-news"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tech News
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-traduzo"
            target="_blank"
            rel="noopener noreferrer"
          >
            Traduzo
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-spotnews"
            target="_blank"
            rel="noopener noreferrer"
          >
            SpotNews
          </a>
        </li>
        <li>
          <a
            href="https://github.com/rodrigomarsa/project-super-portfolio"
            target="_blank"
            rel="noopener noreferrer"
          >
            Super Portfolio
          </a>
        </li>
      </ul>
    </div>
  );
}

export default Python;
